import CurrencyPicker from "./currencyPicker/CurrencyPicker";

const TopBarComponent = () => {
  const topBar = document.getElementById("top-bar-container");
  const config = topBar.getAttribute("data-config");
  const parsedConfig = JSON.parse(config);
  const styles = parsedConfig.styles;

  console.log("[TopBar] styles from top bar", styles);
  return (
    <div>
      <div
        className="flex flex-col"
        style={{
          backgroundColor: styles.backgroundColor || "#ecebe9",
          color: styles.textColor || "#333333",
        }}
      >
        <CurrencyPicker />
      </div>
    </div>
  );
};

export default TopBarComponent;
